import { render, staticRenderFns } from "./StickyBackgroundComponent.vue?vue&type=template&id=2b7e99cd&scoped=true"
import script from "./StickyBackgroundComponent.vue?vue&type=script&lang=ts"
export * from "./StickyBackgroundComponent.vue?vue&type=script&lang=ts"
import style0 from "./StickyBackgroundComponent.vue?vue&type=style&index=0&id=2b7e99cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e99cd",
  null
  
)

export default component.exports